import type { z } from 'zod';
import { zs } from '@/entities/shared/schemas/zod';

export const documentCategorySchema = zs.enum([
  'identity',
  'legal',
  'medical',
  'insurance',
  'property',
  'finance',
  'vehicle',
  'manual',
  'other',
]);

export type DocumentCategory = z.infer<typeof documentCategorySchema>;
